import React, { useState } from "react";
import Permissions from "./Permissions";
import Report from "./Report";
import Leaves from "./Leaves";

const SwitchTabs = () => {
  const [step, setStep] = useState(1);

  function switchTab() {
    switch (step) {
      case 1:
        return (
          <div>
            <Permissions />
          </div>
        );
      case 2:
        return (
          <div>
            <Leaves />
          </div>
        );

      case 3:
        return (
          <div>
            <Report />
          </div>
        );

      default:
        return (
          <div>
            <Permissions />
          </div>
        );
    }
  }

  return (
    <>
      <div className="p-8">
        <div className="grid grid-cols-5 bg-white rounded-lg ">
          <div
            onClick={() => setStep(1)}
            className={`iskool-tab-item ${
              step === 1 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Permissions</div>
          </div>
          <div
            onClick={() => setStep(2)}
            className={`iskool-tab-item ${
              step === 2 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Leaves</div>
          </div>
          <div
            onClick={() => setStep(3)}
            className={`iskool-tab-item ${
              step === 3 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Reports</div>
          </div>
        </div>
        {/* ------------------------------------------------------------------------------------------- */}
        <div>
          <div>{switchTab()}</div>
        </div>
      </div>
    </>
  );
};

export default SwitchTabs;
